import { createReducer } from "@reduxjs/toolkit";
import type { ProcessingState } from "@redux/state/shared-types";
import { documentaryResourceArchive, documentaryResourceArchiveReset } from "./documentary-resource-archive";

const initialState: ProcessingState = { processing: "idle" };

export const documentaryResourceArchiveReducer = createReducer<ProcessingState>(initialState, builder => {
  builder.addCase(documentaryResourceArchive.fulfilled, state => {
    return {
      ...state,
      processing: "success",
    };
  });
  builder.addCase(documentaryResourceArchive.pending, state => {
    return {
      ...state,
      processing: "pending",
    };
  });
  builder.addCase(documentaryResourceArchive.rejected, state => {
    return {
      ...state,
      processing: "failed",
    };
  });
  builder.addCase(documentaryResourceArchiveReset, () => {
    return initialState;
  });
});
